import { Outlet } from "react-router-dom";
import BottomNav, { SideNav } from "@/components/BottomNav";

export default function AppShell() {
  return (
    <div className="sw-app-bg min-h-screen">
      <SideNav />
      <div className="md:pl-60">
        <main className="mx-auto max-w-5xl overflow-x-hidden px-4 pb-28 pt-5 md:px-8 md:pb-12 md:pt-8">
          <Outlet />
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
